import { render, staticRenderFns } from "./BookView.vue?vue&type=template&id=173d0323&"
import script from "./BookView.vue?vue&type=script&lang=js&"
export * from "./BookView.vue?vue&type=script&lang=js&"
import style0 from "./BookView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports